import withReducer from '../../store/withReducer'
import EkgReview from './container'
import reducer from './module'

export default withReducer('ekgReview', reducer)(EkgReview)



// WEBPACK FOOTER //
// ./src/legacy/pages/EkgReview/index.js